module.exports = __webpack_public_path__ + "img/cast.bfe4b7b8.svg";